import type React from 'react';

import { Helmet } from 'react-helmet-async';

import { useIsIndexed } from './hooks/useIsIndexed';

export const MetaRobotsContainer: React.FC = () => {
	const indexed = useIsIndexed();

	if (indexed) return null;

	return (
		<Helmet>
			<meta name="robots" content="noindex" />
		</Helmet>
	);
};
